import { combineLatest, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const combineLatestBatch = <typeof combineLatest>(
  function (...args: Parameters<typeof combineLatest>) {
    return combineLatest(...args).pipe(switchMap(v => from(Promise.resolve(v))));
  }
);
